/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Platform_KcalInputs */

const en_platform_kcal = /** @type {(inputs: Platform_KcalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} kcal`)
};

const pl_platform_kcal = /** @type {(inputs: Platform_KcalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} kcal`)
};

/**
* | output |
* | --- |
* | "{amount} kcal" |
*
* @param {Platform_KcalInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_kcal = /** @type {((inputs: Platform_KcalInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_KcalInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_kcal(inputs)
	return en_platform_kcal(inputs)
});